<template>
    <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
        <div class="px-4 sm:px-6">
            <h2 class="text-lg leading-6 font-medium text-gray-900">Total Amount Paid</h2>
        </div>
        <div class="mt-6 flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="overflow-hidden border-t border-gray-200">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th class="text-left px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Category
                                </th>
                                <th class="text-left px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Current Outturn
                                </th>
                                <th class="text-left px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Year to Date
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">
                                    Seed
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.outrun_total | numberInThousands}}
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.ytd_seed | numberInThousands}}
                                </td>
                            </tr>
                            <tr>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">
                                    Hauling Allowance
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.total_freight_amount | numberInThousands}}
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.ytd_haul_allowance | numberInThousands}}
                                </td>
                            </tr>
                            <tr>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">
                                    Additional Advance
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.additional_advance | numberInThousands}}
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.ytd_additional_advance | numberInThousands}}
                                </td>
                            </tr>
                            <tr class="bg-blue-50">
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">
                                    Totals
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.total_paid | numberInThousands}}
                                </td>

                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.ytd_total | numberInThousands}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        outturn: {
            type: Object,
            required: true,
            defualt: {}
        }
    },
}
</script>
